'use client'

import { Avatar, AvatarFallback } from '@repo/ui'

/**
 * Derive a deterministic radial-gradient from an Ethereum address.
 *
 * Mirrors the algorithm used by Reown/AppKit so that the connect-button
 * avatar and the in-dialog avatar look consistent.
 */
function addressToGradient(address: string): string {
  const hex = address
    .toLowerCase()
    .replace(/^0x/, '')
    .replace(/[^a-f0-9]/g, '')
    .slice(0, 6)
    .padEnd(6, '0')
  const n = parseInt(hex, 16)
  const r = (n >> 16) & 0xff
  const g = (n >> 8) & 0xff
  const b = n & 0xff
  const mix = (t: number) =>
    `rgb(${Math.round(r + (255 - r) * t)} ${Math.round(g + (255 - g) * t)} ${Math.round(b + (255 - b) * t)})`
  const [base, t15, t30, t45, t60] = [0, 0.15, 0.3, 0.45, 0.6].map(mix)
  return `radial-gradient(85% 85% at 65% 40%, #fff 0.5%, ${t60} 31%, ${t30} 52%, ${t15} 66%, ${base} 82%, ${t45} 100%)`
}

export function AddressAvatar({
  address,
  size = 24
}: {
  address: string
  /** @deprecated No longer used — ENS avatars are removed for CSP safety. */
  ensImage?: string | null
  size: number
}) {
  return (
    <Avatar style={{ width: size, height: size }}>
      <AvatarFallback style={{ background: addressToGradient(address) }} />
    </Avatar>
  )
}
